import BaseFactory from 'services/sports/default/base-factory';
import Const from 'constants';
import LPClassic from 'services/sports/tennis/lp/lp-classic';

const classesMap = {
    [Const.GAME_TYPE_CLASSIC]: LPClassic,
};

class Factory extends BaseFactory {
    createObj(objectName, params) {
        const {sportConfig} = params;
        const gameType = sportConfig.getGameType();

        if (gameType in classesMap) {
            return new classesMap[gameType](params);
        }

        throw new Error(`Unknown gameType "${gameType}".`);
    }
}

export {Factory};
